import {
  AUTH_BY_CONTRACT_FAILED,
  AUTH_BY_CONTRACT_SUCCESS,
  AUTH_BY_SMS,
} from 'containers/SignupPages/constants';
import { FEATURES } from 'features/features';
import { hasFeature } from 'features/helpers';
import { get } from 'lodash';
import moment from 'moment';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  closeAddNewContractModal,
  getContractAMCBeneficiariesFailed,
  getContractsAMC,
  getContractsAMCFailed,
  getContractsAuto,
  getContractsAutoFailed,
  getContractsEpargn,
  getContractsEpargnFailed,
  getContractsMrh,
  getContractsMrhFailed,
  getDetailContractFailed,
  getDetailsContractMrhFailed,
  getProduitEpargnFailed,
  matchContractSuccess,
  openModalSucces,
  setContractAMCBeneficiaries,
  setContractAMCDetails,
  setContractsAMC,
  setContractsAuto,
  setContractsEpargn,
  setContractsMrh,
  setContractsType,
  setContratsASI,
  setDetailContract,
  setDetailContractFile,
  setDetailContractGaranties,
  setDetailContractMrh,
  setDetailContractService,
  setDetailsContractMrhFiles,
  setDetailsContractMrhGaranties,
  setInfoContract,
  setProduitEpargn,
} from 'store/contract/actions';
import {
  addNewContractApi,
  getContractAMCBeneficiariesApi,
  getContractAMCDetailsApi,
  getContractASIApi,
  getContractMRHApi,
  getContractsAmcApi,
  getContractsAutoApi,
  getContractsEpargnApi,
  getContractsEpargnApiV2,
  getContractsTypeApi,
  getDetailContractApi,
  getDetailsContractMrhApi,
  getInfoProduitApi,
  verifyEligibilityByContractNotnumApi,
} from 'store/contract/apis';
import {
  ADD_NEW_CONTRACT,
  GET_CLIENT_CONTRACT_ASI,
  GET_CONTRACTS_AMC,
  GET_CONTRACTS_AMC_DETAIL,
  GET_CONTRACTS_AUTO,
  GET_CONTRACTS_EPARGN,
  GET_CONTRACTS_MRH,
  GET_CONTRACTS_TYPE,
  GET_CONTRACT_DETAIL,
  GET_DETAILS_CONTRACT_MRH,
  GET_PRODUIT_EPARGN,
} from 'store/contract/constants';
import { SetTabs, setToasterOpen } from 'store/global/actions';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getSinistres } from 'store/sinistre/actions';
import {
  setPinId,
  SetRoles,
  setSignupStep,
  setToken,
  submitSignupStepFail,
  submitSignupStepSuccess,
} from 'store/user/actions';
import { getIsUserFoundSelector, userSelector } from 'store/user/selectors';
import { UserSelectorType } from 'store/user/types';
import { PRIVILEGES } from 'utils/globalConst';
import labels from 'utils/labels';
import { formatEpargnProducts, tabsFromResponse } from 'utils/string';
import {
  ContractAutoInfoSelectorType,
  ContractMrhInfoSelectorType,
  verifyEligibilityByContractNotnumPayloadType,
} from './types';

interface ResponseGenerator {
  data?: any;
}
export function* getContractsType() {
  try {
    const language: string = yield select(getLocaleSelector);
    const response: ResponseGenerator = yield call(getContractsTypeApi, {
      language,
    });

    if (response.data.success) {
      yield put(setContractsType(response.data.data));
    }
  } catch (error) {
    yield put(setContractsType(''));
  }
}

export function* authByContract(
  payload: verifyEligibilityByContractNotnumPayloadType,
) {
  try {
    const { firstName, lastName, cin, phone, bday } = yield select(
      userSelector,
    );
    const token = localStorage.getItem('token');
    const { organisme, drpp, numAdhesion, typeAssurance: type } = payload;
    const dataToSend = {
      firstName,
      lastName,
      cin,
      phone,
      type,
      numPolice: payload.numPolice,
      dateEcheance: moment(payload.dateEffet).format('DD/MM/YYYY'),
      token,
      bday,
      ...(type === PRIVILEGES.AMC && {
        organisme,
        drpp,
        numAdhesion,
      }),
    };

    const isUserFound: boolean = yield select(getIsUserFoundSelector);
    yield put(
      setInfoContract({
        type: payload.typeAssurance,
        numPolice: payload.numPolice,
        dateEcheance: payload.dateEffet,
      }),
    );
    const { data: response } = yield call(
      verifyEligibilityByContractNotnumApi,
      { dataToSend, isUserFound },
    );
    if (response.success) {
      if (get(response, 'data.code_error') === 1003) {
        yield put(
          setToasterOpen({
            title: 'defaultErrorMessage',
            severity: 'error',
          }),
        );
        yield put(submitSignupStepFail('defaultErrorMessage'));
      } else {
        const isAmc = response.data?.isamc;
        const { key1, key2, key3, typeContract, login } = isAmc
          ? response.data.contractAMC
          : response.data;
        if (isAmc) {
          yield put(setPinId(response.data.pinId));
        }
        yield put(matchContractSuccess({ key1, key2, key3, typeContract }));
        yield put(
          submitSignupStepSuccess({ login, token: response.data.token }),
        );
        yield put(
          setSignupStep(isAmc ? AUTH_BY_SMS : AUTH_BY_CONTRACT_SUCCESS),
        );
      }
    } else {
      yield put(setSignupStep(AUTH_BY_CONTRACT_FAILED));
    }
  } catch (error) {
    yield put(setSignupStep(AUTH_BY_CONTRACT_FAILED));
  }
}

export function* watchGetContractsType() {
  yield takeLatest(GET_CONTRACTS_TYPE, getContractsType);
}
export function* getContractAuto() {
  try {
    const response: ResponseGenerator = yield call(getContractsAutoApi);

    if (response.data.success) {
      yield put(setContractsAuto(response.data.data));
    }
  } catch (error) {
    yield put(getContractsAutoFailed(error));
  }
}

export function* watchgetContractAuto() {
  yield takeLatest(GET_CONTRACTS_AUTO, getContractAuto);
}
export function* getDetailContract({
  payload,
}: {
  type: typeof GET_CONTRACT_DETAIL;
  payload: ContractAutoInfoSelectorType;
}) {
  try {
    const language: string = yield select(getLocaleSelector);
    const response: ResponseGenerator = yield call(getDetailContractApi, {
      lang: language,
      policyNumber: payload.policyNumber,
      circulationDate: payload.circulationDate,
    });
    if (response.data.success) {
      yield put(setDetailContract(response.data.data.prime));
      yield put(setDetailContractFile(response.data.data.files));
      yield put(
        setDetailContractService(
          get(response.data.data.details, '[1].content'),
        ),
      );
      yield put(
        setDetailContractGaranties(
          get(response.data.data.details, '[0].content'),
        ),
      );
    }
  } catch (error) {
    yield put(getDetailContractFailed(error));
  }
}
export function* watchgetDetailContractAuto() {
  yield takeLatest(GET_CONTRACT_DETAIL, getDetailContract);
}
export function* getContractMrh() {
  try {
    const response: ResponseGenerator = yield call(getContractMRHApi);
    if (response.data.success) {
      yield put(setContractsMrh(response.data.data));
    }
  } catch (error) {
    yield put(getContractsMrhFailed(error as string));
  }
}
export function* watchgetContractMrh() {
  yield takeLatest(GET_CONTRACTS_MRH, getContractMrh);
}

const TITLE_BY_ERROR_CODE: Record<number, string> = {
  1015: 'contractIncorrect',
  1011: 'policyNumberAlreadyBeenAdded',
  500: 'defaultErrorMessage',
  1006: labels.addNewContractNotFountAMC,
  1600: labels.addNewContractNotFountAMC,
};

const getTitleByErrorCode = (error: any): string => {
  const errorCode = get(error, 'response.data.code_error', 500);
  return TITLE_BY_ERROR_CODE[errorCode] || TITLE_BY_ERROR_CODE[500];
};

export function* addNewContract({
  payload,
}: {
  type: typeof ADD_NEW_CONTRACT;
  payload: any;
}) {
  try {
    const token = localStorage.getItem('token');
    const user: UserSelectorType = yield select(userSelector);
    const dataToSend = {
      ...payload,
      firstName: user.firstName,
      lastName: user.lastName,
      bday: user.bday,
      cin: user.cin,
      phone: user.phone,
      token: token,
    };
    const response: ResponseGenerator = yield call(
      addNewContractApi,
      dataToSend,
    );
    if (response.data.success) {
      yield put(SetRoles(response.data.data.privilege));
      yield put(setToken(response.data.data.token));
      const tabs = tabsFromResponse(response.data.data.privilege);
      yield put(SetTabs(tabs));
      localStorage.setItem('tabs', JSON.stringify(tabs));
      yield put(closeAddNewContractModal());
      yield put(openModalSucces());
      if (get(response.data, 'data.addedContract.type') === PRIVILEGES.AUTO) {
        yield put(getContractsAuto());
        yield put(getSinistres());
      } else if (
        get(response.data, 'data.addedContract.type') === PRIVILEGES.MRH
      ) {
        yield put(getContractsMrh());
      } else if (
        get(response.data, 'data.addedContract.type') === PRIVILEGES.EPARGN
      ) {
        localStorage.setItem('token', get(response.data, 'data.token'));
        yield put(getContractsEpargn());
      } else if (
        get(response.data, 'data.addedContract.type') === PRIVILEGES.AMC
      ) {
        yield call(getContractAMCBeneficiariesSaga);
        yield put(getContractsAMC());
      }
    }
  } catch (error) {
    yield put(
      setToasterOpen({
        title: getTitleByErrorCode(error),
        severity: 'error',
      }),
    );
  }
}
export function* watchAddNewContract() {
  yield takeLatest(ADD_NEW_CONTRACT, addNewContract);
}
export function* getDetailContractMrh({
  payload,
}: {
  type: typeof GET_DETAILS_CONTRACT_MRH;
  payload: ContractMrhInfoSelectorType;
}) {
  try {
    const language: string = yield select(getLocaleSelector);
    const response: ResponseGenerator = yield call(getDetailsContractMrhApi, {
      lang: language,
      policyNumber: payload.policyNumber,
    });
    if (response.data.success) {
      yield put(setDetailContractMrh(response.data.data.prime));
      yield put(setDetailsContractMrhGaranties(response.data.data.content));
      yield put(setDetailsContractMrhFiles([response.data.data.file]));
    }
  } catch (error) {
    yield put(getDetailsContractMrhFailed(error as string));
  }
}
export function* watchGetDetailContractMrh() {
  yield takeLatest(GET_DETAILS_CONTRACT_MRH, getDetailContractMrh);
}
export function* getContractEpargn() {
  try {
    const token = localStorage.getItem('token');
    let response: ResponseGenerator;
    if (hasFeature(FEATURES.ACAPS)) {
      response = yield call(getContractsEpargnApiV2, { token: token });
    } else {
      response = yield call(getContractsEpargnApi, { token: token });
    }
    if (response.data.success) {
      const contractsEpargn = response.data.data;
      yield put(setContractsEpargn(contractsEpargn));
    }
  } catch (error) {
    yield put(getContractsEpargnFailed(error as string));
  }
}
export function* watchgetContractEpargn() {
  yield takeLatest(GET_CONTRACTS_EPARGN, getContractEpargn);
}
export function* getProduitEpargn() {
  try {
    const response: ResponseGenerator = yield call(getInfoProduitApi);
    if (response.data.success) {
      yield put(
        setProduitEpargn(
          formatEpargnProducts(
            get(response.data.data, '[0].GetInfoProduitResult.Produit'),
          ),
        ),
      );
    }
  } catch (error) {
    yield put(getProduitEpargnFailed(error as any));
    if (get(error, 'response.data.code_error'))
      /* istanbul ignore file */
      yield put(
        setToasterOpen({
          title: 'errorToaster',
          severity: 'error',
        }),
      );
  }
}
export function* watchgetProduitEpargn() {
  yield takeLatest(GET_PRODUIT_EPARGN, getProduitEpargn);
}

export function* getContractAMCBeneficiariesSaga() {
  try {
    const response: ResponseGenerator = yield call(
      getContractAMCBeneficiariesApi,
    );
    const data = get(response, 'data', {});
    if (data.success) yield put(setContractAMCBeneficiaries(data.data));
  } catch (error) {
    yield put(getContractAMCBeneficiariesFailed(error as any));
  }
}

export function* getContractsAMCSaga() {
  try {
    const response: ResponseGenerator = yield call(getContractsAmcApi);
    const data = get(response, 'data', {});
    if (data.success) yield put(setContractsAMC(data.data));
    yield call(getContractAMCBeneficiariesSaga);
  } catch (error) {
    yield put(getContractsAMCFailed(error as any));
  }
}

export function* watchGetContractsAMCSaga() {
  yield takeLatest(GET_CONTRACTS_AMC, getContractsAMCSaga);
}

export function* getContractsASISaga({
  payload,
}: {
  type: typeof GET_CLIENT_CONTRACT_ASI;
  payload: { language: string };
}) {
  try {
    const response: ResponseGenerator = yield call(getContractASIApi, {
      language: payload.language,
    });
    const data = get(response, 'data', {});
    if (data.success) yield put(setContratsASI(data.data));
  } catch (error) {
    // TODO: on error
  }
}

export function* watchGetContractsASISaga() {
  yield takeLatest(GET_CLIENT_CONTRACT_ASI, getContractsASISaga);
}

export function* getContractAMCDetailsSaga({
  payload,
}: {
  type: typeof GET_CONTRACTS_AMC_DETAIL;
  payload: { language: string; policyNumbers: string[] };
}) {
  try {
    const response: ResponseGenerator = yield call(getContractAMCDetailsApi, {
      language: payload.language,
      policyNumbers: payload.policyNumbers,
    });
    const data = get(response, '[0].data', []);
    if (data.success) yield put(setContractAMCDetails(data.data));
  } catch (error) {
    // TODO: on error
  }
}

export function* watchGetContractAMCDetailsSaga() {
  yield takeLatest(GET_CONTRACTS_AMC_DETAIL, getContractAMCDetailsSaga);
}
